import React, { useState, useEffect } from "react";
import { Box, Text, Flex, Menu, MenuButton, MenuList, MenuItem, Button, Image, Heading } from "@chakra-ui/react";
import MenuArrow from "../Images/Menu_Arrow.svg";
import Arrow from "./Landing Page/CallToActionArrowButton.svg";
import axios from "axios";
import { BASE_API_URL } from './config';
import { a } from "./appColors";

const SubjectTopicTracker = () => {
  const [selectedSubjectGuid, setSelectedSubjectGuid] = useState(null);
  const [selectedSubjectName, setSelectedSubjectName] = useState("Subject");
  const [subjects, setSubjects] = useState([]);
  const [topicsThatNeedAttention, setTopicsThatNeedAttention] = useState ([]);
  const [topics, setTopics] = useState([]);
  const [totalQuestionsAttempted, setTotalQuestionsAttempted] = useState(0);
  const [activeTopic, setActiveTopic] = useState(null);
  const [permissionAccess, setPermissionAccess] = useState(null);
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await axios.get(`${BASE_API_URL}/api/v1/user-subject-links/own/detail`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setSubjects(response.data);
      } catch (err) {
        console.error("Failed to fetch subjects.", err);
      }
    };

    fetchSubjects();
  }, [accessToken]);


  useEffect(() => {
    if (subjects.length > 0 && !selectedSubjectGuid) {
      setSelectedSubjectGuid(subjects[0].guid);
      setSelectedSubjectName(subjects[0].subject_name);
    }
  }, [subjects]);
 
  useEffect(() => {
    const fetchTrackingData = async () => {
      if (!selectedSubjectGuid) return;

      try {
        const response = await axios.get(
          `${BASE_API_URL}/api/v1/tracking/user-subject-topic/${selectedSubjectGuid}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        const trackingData = response.data;
        setTotalQuestionsAttempted(trackingData.total_question_attempted_count);
        const uniqueTopics = trackingData.subject_topics.filter((topic, index, self) =>
          index === self.findIndex(t => t.name === topic.name)
        ); 
        setTopics(uniqueTopics);
        setPermissionAccess(trackingData.permission_access);
        setTopicsThatNeedAttention(trackingData.least_attempted_topics); 
        
      } catch (err) {
        console.error("Failed to fetch tracking data.", err);
      }
    };

    if (selectedSubjectGuid) {
      fetchTrackingData();
    }
  }, [selectedSubjectGuid, accessToken]);


  const handleUpgradeClick = async () => {
    const token = `Bearer ${localStorage.getItem('accessToken')}`;

    try {
      // Fetch the user's active_subscription_plan_guid
      const userResponse = await fetch(`${BASE_API_URL}/api/v1/users/own`, {
        headers: {
          Authorization: token,
        },
      });

      if (!userResponse.ok) {
        throw new Error('Failed to fetch user data');
      }

      const userData = await userResponse.json();
      //const activeSubscriptionPlanGuid = userData.active_subscription_plan_guid;

      const checkoutResponse = await fetch(`${BASE_API_URL}/api/v1/user-subscription-plans/create-checkout-session`, {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          subscription_plan_guid: "298eb053-7c3a-45d6-967f-f73508517aa9",
          stripe_price_id: "price_1QkqC7C7LkUNUnN8V3nYcQd8",
          renewal_type: "MONTHLY",
        }),
      });

      if (!checkoutResponse.ok) {
        throw new Error('Failed to create checkout session');
      }

      const checkoutData = await checkoutResponse.json();
      const checkoutUrl = checkoutData.checkout_url;

      window.location.href = checkoutUrl;
    } catch (err) {
      console.error('Error creating checkout session:', err.message);
    }
  };

  const handleSubjectSelect = (subject) => {
    setSelectedSubjectGuid(subject.guid);
    setSelectedSubjectName(subject.subject_name);
  };

  const handleHover = (index) => {
    setActiveTopic(index);
  };

  const handleClick = (index) => {
    setActiveTopic(index);
  };

  const handleMouseLeave = () => {
    setActiveTopic(null);
  };

  return (
    <Box
    width= "658px"
    //w={{ base: "100%", md: "50%" }}
    height="400px"
    border="2px solid" borderColor={a.border}
    borderRadius="14px"
    p="20px"
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    overflow="hidden"
    position="relative"
  >
    <Flex justifyContent="space-between" alignItems="flex-start" height="180px">
      <Box>
        <Heading color={a.text} fontSize="20px" fontWeight="400">
          Topics to focus on per subject
        </Heading>
        <Text color={a.textSub} fontSize="12px" fontWeight="200" mt="4px" width="320px">
          {selectedSubjectGuid
            ? "Your overall performance is measured based on the papers you are solving at the moment"
            : "Please select a subject and solve questions to see topics that need your attention"}
        </Text>
      </Box>
      <Flex flexDirection="column" alignItems="flex-end" width="410px">
        <Menu>
          <MenuButton
            as={Button}
            variant="menuButton"
            width="122px"
            height="28px"
            fontSize="14px"
            fontWeight="400"
            background={a.surface}
            border="2.333px solid" borderColor={a.border}
            borderRadius="9.333px"
            _hover={{ background: a.surface }}
            _focus={{ boxShadow: "none" }}
            rightIcon={
              <img
                src={MenuArrow}
                alt="menu arrow"
                style={{ marginLeft: "8px" }}
              />
            }
          >
            {selectedSubjectName}
          </MenuButton>
          <MenuList
            background={a.surface}
            color={a.text}
            textAlign="center"
            fontSize="12px"
            fontWeight="300"
          >
            {subjects.map((subject, index) => (
              <MenuItem key={index} onClick={() => handleSubjectSelect(subject)}>
                {subject.subject_name}
              </MenuItem> 
            ))}
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  
    <Box position="relative" mt="20px">
      <Flex
        justifyContent="center"
        alignItems="center"
        position="relative"
        width="100%"
        height="220px"
      >
        {topicsThatNeedAttention.length > 0 && (
          <>
            <Box
              width="200px"
              height="200px"
              flexShrink="0"
              background="#FF4716"
              border="2px solid" borderColor={a.surface}
              borderRadius="50%"
              display="flex"
              justifyContent="center"
              alignItems="center"
              zIndex="1"
              position="relative"
              top="5px"
              right="5px"
              px="10px"
              textAlign="center"
            >
              <Text
                color="#FFFFFF"
                fontSize="14px"
                fontWeight="400"
                whiteSpace="normal"
              >
                {topicsThatNeedAttention[0]}
              </Text>
            </Box>
            {topicsThatNeedAttention.length > 1 && (
              
              <Box
                width="200px"
                height="200px"
                flexShrink="0"
                background="#9AE9FE"
                border="2px solid" borderColor={a.surface}
                borderRadius="50%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                position="relative"
                top="-25px"
                left="-15px"
                px="10px"
                textAlign="center"
              >
                <Text
                  color="#000000"
                  fontSize="14px"
                  fontWeight="400" 
                  whiteSpace="normal"
                >
                  {topicsThatNeedAttention[1]}
                </Text>
              </Box>
          
            )}
          </>
        )}
      </Flex>
  
      <Flex flexDirection="column" alignItems="flex-start" mt="12px" ml="20px">
        <Text color={a.text} fontSize="20px" fontWeight="500">
          {totalQuestionsAttempted > 0
            ? `${totalQuestionsAttempted} Questions`
            : "0 Questions"}
        </Text>
        <Text color={a.textSub} fontSize="12px" fontWeight="300" mt="4px">
          solved for this subject so far
        </Text>
      </Flex>
    </Box>
  
    {(permissionAccess === "LIMITED" || permissionAccess === "DENIED") && (
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg={a.overlay}
        backdropFilter="blur(2px)"
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderRadius="14px"
        zIndex="2"
        p="20px"
      >
        <Box textAlign="center">
          <Text fontSize="16px" mb="12px" color={a.text}>
            Upgrade to premium to access this
          </Text>
          
        </Box>
      </Box>
    )}
  </Box> 

  );
};

export default SubjectTopicTracker;
